import React from "react";

const HeroSection = () => {
  return (
    <section
      style={{
        width: "100%",
        minHeight: "220px",
        maxHeight: "500px",
        padding: "22px 0",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "16px",
        boxShadow: "0 2px 16px rgba(139,115,85,0.2)",
         backgroundColor:"#f9f9f9"
      }}
    >
      <div style={{ maxWidth: 900, width: "100%", padding: "0 32px", textAlign: "center" }}>
        <h1
          style={{
            color: "var(--primary-color)",
            fontSize: "1.6rem",
            fontWeight: 400,
            marginBottom: "20px",
            fontFamily: "'Jost','Poppins', 'Segoe UI', sans-serif"
          }}
        >
          Effortless Casual Wear for Modern Styles
        </h1>
        <p
          style={{
            color: "var(--text-secondary)",
            fontSize: "1rem",
            maxWidth: 680,
            margin: "0 auto 22px auto",
            fontWeight: 400
          }}
        >
          At SYUKRA, discover timeless casual shirts and elevated essentials designed for all-day comfort and understated elegance. Redefine everyday dressing with curated fabrics, relaxed fits, and iconic neutral palettes—crafted for your unique lifestyle.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
